<template>
    <div>
      <!-- MainHeader -->
      <MainHeader />
  
      <!-- MainNavbar mit linkem Menu -->
      <MainNavbar
        :showContentNav="true"
        :sections="sectionsContent"
      />
  
      <!-- Hauptinhaltsbereich -->
      <main>
        <!-- Hier binden wir unsere ImpressumContent-Komponente ein -->
        <ImpressumContent
          @sections-content-updated="updateSectionsContent"
        />
      </main>
    </div>
  </template>
  
  <script>
  import MainHeader from '@/components/MainHeader.vue';
  import MainNavbar from '@/components/MainNavbar.vue';
  import ImpressumContent from '@/components/ImpressumContent.vue';
  
  export default {
    name: 'ImpressumView', // oder "ImpressumPageView"
    components: {
      MainHeader,
      MainNavbar,
      ImpressumContent,
    },
    data() {
      return {
        sectionsContent: [], // wird von ImpressumContent gefüllt
      };
    },
    methods: {
      updateSectionsContent(sections) {
        // Sobald ImpressumContent gemountet ist, bekommen wir die Sections
        // und geben sie an die Navbar (MainNavbar) weiter.
        this.sectionsContent = sections;
      },
    },
  };
  </script>
  
  <style scoped>
  main {
    padding-top: 40px;
    margin-top: 0;
  }
  </style>
  